import { Injectable } from '@angular/core';
import { of, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenericServiceService {
  
  isPayrollEnabled = new BehaviorSubject<boolean>(false);
  
  constructor() { }

}
